import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router, RouterEvent } from 'aurelia-router';
import { log } from 'framework/script_utilities/dev-decorators';
import { HOME_ROUTE } from 'support/settings';

@autoinject
export class SystemErrorScreen {
  routerErrorSubscription: Subscription;
  routerCompleteSubscription: Subscription;
  navigating: boolean;
  error: unknown;

  constructor(private router: Router, private ea: EventAggregator) { }

  @log('debug')
  activate() {
    this.navigating = false;
    this.error = null;
  }

  attached() {
    this.routerErrorSubscription = this.ea.subscribe(RouterEvent.Error, event => this.navigationError(event.result.output));
    this.routerCompleteSubscription = this.ea.subscribe(RouterEvent.Complete, () => this.navigationComplete());
  }

  detached() {
    this.routerErrorSubscription.dispose();
    this.routerCompleteSubscription.dispose();
  }

  @log('debug')
  navigationError(error: unknown) {
    this.navigating = false;
    this.error = error;
  }

  @log('debug')
  navigationComplete() {
    if (!this.error) {
      this.navigating = true;
      this.router.navigate(HOME_ROUTE, { replace: true });
    }
  }
}
